module.exports = __webpack_public_path__ + "static/media/teoLogo2BlancV2.c02ce323.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogo2BlancV2.png
// module id = 403
// module chunks = 0